import { productCtas, productCtasButtonType } from '@pes-ui/utils/lib/constants';
export const MAX_VISIBLE_CARDS_WHILE_COLLAPSED = 3;
export const MAX_RANGES_BEFORE_SDL_PROMO_BANNER = 2;
export const listingTypes = {
  SUBCATEGORY_LISTING: 'subcategory listing',
  CATEGORY_LISTING: 'category listing',
};
export const pageParam = {
  SUBCATEGORY_LISTING: 'subcategoryListing',
  CATEGORY_LISTING: 'categoryListing',
  RANGE_LISTING: 'rangeListing',
};
export const DEFAULT_CATEGORY_PRODUCT_CTAS = Object.assign(Object.assign({}, productCtas), { buttons: {
    [productCtasButtonType.CART]: Object.assign({ isShown: false }, productCtas.buttons[productCtasButtonType.CART]),
    [productCtasButtonType.FAVORITES]: Object.assign({ isShown: false }, productCtas.buttons[productCtasButtonType.FAVORITES]),
  } });
